module.exports = __webpack_public_path__ + "static/img/download_bg_01.3690449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download_bg_01.png
// module id = QnLD
// module chunks = 1